/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Interceptor module for checking responses for the errors related to cookies.
 */
'use strict';

angular
  .module('interceptor.cookie', [])
  /**
   * A factory that registers the interceptor logic checking for errors related to cookies not being enabled.
   */
  .factory('allowCookiesInterceptor', function ($q, $rootScope, $filter, HTTP_ERROR_STATUS, ALERT_EVENTS) {
    return {
      // On response failure
      responseError: function (rejection) {
        var allCookiesErrorMessage = "Unauthorized: Allow cookies from 3rd parties in your browser's preferences";
        // For this case only care about 401's that have the specific cookie message.
        if (rejection.status === HTTP_ERROR_STATUS.UNAUTHORIZED && rejection.data.message === allCookiesErrorMessage) {
          $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('ALLOW_COOKIES'), true);

          return rejection;
        } else {
          // Return the promise rejection for other errors.x
          return $q.reject(rejection);
        }
      }
    };
  });
